const styles = {
  container: {
    root: {
      paddingTop: '7rem',
      '@media (max-width: 46em)': {
        paddingTop: '1.5rem'
      }
    }
  },
  mobileBottomBar: {
    position: 'fixed',
    bottom: '0px',
    left: 0,
    right: 0,
    background: '#fff',
    boxShadow: '0 -2px 10px rgba(0, 0, 0, 0.1)',
    padding: '0.75rem',
    zIndex: 100,
    textAlign: 'center',
    display: 'none',
    '@media (max-width: 46em)': {
      display: 'block'
    },
    transform: 'translateY(100%)',
    transition: 'transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)'
  },
  mobileButton: {
    width: '100%',
    padding: '0.75rem'
  }
}

export default styles
